(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pb-life-layer"] && !Shopify.designMode) return;
  try {
    (function () {
    var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hd = document.querySelector('header');
    var tt = document.querySelector('.totop');
    function onScroll() {
      var y = window.scrollY || 0;
      if (hd) hd.classList.toggle('scrolled', y > 8);
      if (tt) tt.classList.toggle('show', y > 640);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    if (!rm && 'IntersectionObserver' in window) {
      document.documentElement.classList.add('anim');
      var els = document.querySelectorAll('[data-reveal]');
      els.forEach(function (el, i) {
        el.style.transitionDelay = ((i % 4) * 70) + 'ms';
      });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      els.forEach(function (el) { io.observe(el); });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pb-quick-add"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pbQaInit) return;
    window.__pbQaInit = true;

    var overlay = document.getElementById('pbQaOverlay');
    if (!overlay) return;
    var modal = document.getElementById('pbQaModal');
    var els = {
      img: document.getElementById('pbQaImg'),
      tag: document.getElementById('pbQaTag'),
      name: document.getElementById('pbQaName'),
      price: document.getElementById('pbQaPrice'),
      blurb: document.getElementById('pbQaBlurb'),
      opts: document.getElementById('pbQaOpts'),
      qty: document.getElementById('pbQaQty'),
      add: document.getElementById('pbQaAdd'),
      addTxt: document.getElementById('pbQaAddTxt'),
      sold: document.getElementById('pbQaSold'),
      full: document.getElementById('pbQaFull')
    };
    var CURRENCY = overlay.getAttribute('data-currency') || 'USD';

    var cache = {};
    var data = null;     // fetched /products/<handle>.js
    var model = [];      // [{ name, index, values:[] }]
    var sel = {};        // option name -> chosen value
    var qty = 1;
    var lastTrigger = null;

    function money(cents) {
      try {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: CURRENCY, currencyDisplay: 'narrowSymbol' }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function fetchProduct(handle) {
      if (cache[handle]) return Promise.resolve(cache[handle]);
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (json) { if (json) cache[handle] = json; return json; })
        .catch(function () { return null; });
    }

    function matchedVariant() {
      if (!data) return null;
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        var ok = true;
        for (var j = 0; j < model.length; j++) {
          if (v.options[model[j].index] !== sel[model[j].name]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    // A value is enabled only if some AVAILABLE variant has it given the current
    // selections of the OTHER options.
    function valueAvailable(o, val) {
      return data.variants.some(function (v) {
        if (!v.available) return false;
        if (v.options[o.index] !== val) return false;
        return model.every(function (oo) { return oo.index === o.index || v.options[oo.index] === sel[oo.name]; });
      });
    }

    function renderOptions() {
      els.opts.innerHTML = '';
      model.forEach(function (o) {
        var wrap = document.createElement('div');
        wrap.className = 'qa-opt';
        var label = document.createElement('div');
        label.className = 'qa-opt-label';
        label.innerHTML = o.name + '<span class="qa-chosen">&middot; ' + escapeHtml(sel[o.name]) + '</span>';
        wrap.appendChild(label);
        var row = document.createElement('div');
        row.className = 'qa-opt-vals';
        o.values.forEach(function (val) {
          var disabled = !valueAvailable(o, val);
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'qa-vpill' + (sel[o.name] === val ? ' sel' : '');
          btn.textContent = val;
          if (disabled) btn.setAttribute('disabled', '');
          btn.addEventListener('click', function () {
            if (disabled) return;
            sel[o.name] = val;
            syncModal();
          });
          row.appendChild(btn);
        });
        wrap.appendChild(row);
        els.opts.appendChild(wrap);
      });
    }

    function setImage() {
      var m = matchedVariant();
      var src = (m && m.featured_image && m.featured_image.src) ? m.featured_image.src : data.featured_image;
      if (src) {
        if (src.indexOf('//') === 0) src = 'https:' + src;
        var img = new Image();
        img.alt = data.title || '';
        img.src = src;
        els.img.innerHTML = '';
        els.img.appendChild(img);
        els.img.classList.remove('qa-img--empty');
      } else {
        els.img.innerHTML = '';
        els.img.classList.add('qa-img--empty');
      }
    }

    function syncModal() {
      renderOptions();
      setImage();
      var m = matchedVariant();
      els.price.textContent = m ? money(m.price) : '--';
      els.sold.textContent = '';
      if (m && m.available) {
        els.add.removeAttribute('disabled');
        els.addTxt.textContent = 'Add to bucket';
      } else {
        els.add.setAttribute('disabled', '');
        els.addTxt.textContent = m ? 'Sold out' : 'Unavailable';
        if (m) els.sold.textContent = "That combo's sold out, try another.";
      }
    }

    function build(subtitle) {
      model = (data.options || []).map(function (o, i) {
        var name = (typeof o === 'string') ? o : o.name;
        var seen = {}, values = [];
        data.variants.forEach(function (v) {
          var val = v.options[i];
          if (val != null && !seen[val]) { seen[val] = 1; values.push(val); }
        });
        return { name: name, index: i, values: values };
      });
      sel = {};
      model.forEach(function (o) {
        var first = null;
        for (var k = 0; k < o.values.length; k++) {
          var val = o.values[k];
          if (data.variants.some(function (v) { return v.available && v.options[o.index] === val; })) { first = val; break; }
        }
        sel[o.name] = first || o.values[0];
      });
      qty = 1;
      els.qty.textContent = '1';
      els.tag.textContent = data.type || '';
      els.name.textContent = data.title || '';
      if (subtitle) { els.blurb.textContent = subtitle; els.blurb.hidden = false; }
      else { els.blurb.textContent = ''; els.blurb.hidden = true; }
      els.full.setAttribute('href', '/products/' + data.handle);
      syncModal();
    }

    function openModal(trigger) {
      var handle = trigger.getAttribute('data-quick-add');
      if (!handle) return;
      lastTrigger = trigger;
      var subtitle = trigger.getAttribute('data-qa-subtitle') || '';
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('qa-open');
      modal.classList.add('is-loading');
      els.sold.textContent = '';
      fetchProduct(handle).then(function (json) {
        modal.classList.remove('is-loading');
        if (!json || !json.variants) { els.sold.textContent = "Couldn't load options, please try the product page."; return; }
        data = json;
        build(subtitle);
        var firstFocus = modal.querySelector('.qa-vpill:not([disabled]), .qa-close');
        if (firstFocus) firstFocus.focus();
      });
    }

    function closeModal() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('qa-open');
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    }

    function setAdding(on) {
      if (on) { els.add.setAttribute('disabled', ''); els.addTxt.textContent = 'Adding...'; }
      else { els.add.removeAttribute('disabled'); els.addTxt.textContent = 'Add to bucket'; }
    }

    function addToBucket() {
      var m = matchedVariant();
      if (!m || !m.available) return;
      setAdding(true);
      els.sold.textContent = '';
      var api = (window.PBCart && window.PBCart.addVariant) ? window.PBCart.addVariant : null;
      var p = api ? api(m.id, qty) : Promise.resolve({ error: true });
      p.then(function (res) {
        if (res && !res.error) {
          closeModal();
          return;
        }
        setAdding(false);
        if (res && res.status === 422 && res.description) els.sold.textContent = res.description;
        else els.sold.textContent = "Couldn't add that, try again.";
      });
    }

    function escapeHtml(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    // Triggers anywhere on the page (delegated, survives grid re-renders)
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-quick-add]');
      if (!t) return;
      e.preventDefault();
      openModal(t);
    });

    els.add.addEventListener('click', addToBucket);
    document.getElementById('pbQaPlus').addEventListener('click', function () { qty++; els.qty.textContent = qty; });
    document.getElementById('pbQaMinus').addEventListener('click', function () { if (qty > 1) qty--; els.qty.textContent = qty; });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
      if (e.target.closest('[data-qa-close]')) closeModal();
    });

    // Esc to close + focus trap within the modal while open
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key !== 'Tab') return;
      var f = modal.querySelectorAll('button:not([disabled]), a[href], input, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
